import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, Children, isValidElement, cloneElement } from 'react';
import { Box } from '../Box/index.js';
import { Input } from '../Input/index.js';
import { InputLeftElement } from '../InputElement/index.js';

/**
 * InputElemGroup is used with InputLeftElement or InputRightElement to
 * add icons on either side of the Input component.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input/#input-w-icon)
 * <br />
 *
 */
const InputElemGroup = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    iconRightSpacing,
    ...props
  } = _ref;
  let pl;
  // let pr: number;
  const spacing = 40;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    display: "flex",
    position: "relative"
  }, props), Children.map(children, child => {
    if (! /*#__PURE__*/isValidElement(child)) return;
    if (child.type === InputLeftElement) {
      pl = spacing;
    }
    // if (child.type === InputRightElement) {
    //   pr = spacing;
    // }
    if (child.type === Input) {
      return /*#__PURE__*/cloneElement(child, {
        pl: child.props.pl || pl,
        pr: child.props.pr || iconRightSpacing && spacing
      });
    }
    return /*#__PURE__*/cloneElement(child);
  }));
});

export { InputElemGroup };
